(function () {
    'use strict';

    angular
        .module('jcsfApp')
        .factory('projectsService', projectsService);

    projectsService.$inject = ['$http', '$filter', 'modelTransformer', 'messaging', 'events', 'Project', 'FireHour'];

    function projectsService($http, $filter, modelTransformer, messaging, events, Project) {
        var baseUrl = '/api/Project/';
        var projects = [];
        var dId = 0;
        var project = {};
        var service = {
            init: init
        }; 
        messaging.subscribe(events.message._GET_PROJECT_RESOURCES_LIST_, getProjectResources);
        messaging.subscribe(events.message._GET_PROJECT_LIST_, getProjects);
        messaging.subscribe(events.message._DELETE_PROJECT_, deleteProject);
        messaging.subscribe(events.message._GET_PROJECT_, getProject);
        messaging.subscribe(events.message._SAVE_PROJECT_, saveProject);
        messaging.subscribe(events.message._SAVE_SUCCESS_, showSuccess);
        return service;
        function init() {
            projects = [];
            project = {};
        }

        function getProjects(clear, id) {
            if (clear === true) {
                projects = [];
            }

            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetList/' + id;

            $http.get(baseUrl + url)
                .then(getProjectsSuccessHandler, getProjectsErrorHandler);

        }
        function getProjectResources(){
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            var url = 'GetResources/';

            $http.get(baseUrl + url)
                .then(getProjectResourcesSuccessHandler, getProjectResourcesErrorHandler);
        }
        function getProject(id) {

            dId = id;
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.get(baseUrl + 'Get/' + dId)
                .then(getProjectSuccessHandler, getProjectErrorHandler);

        }
        function deleteProject(id) {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'deleteProject/' + id)
                .then(deleteProjectSuccessHandler, deleteProjectErrorHandler);
        }
        function saveProject(src) {

            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post(baseUrl + 'saveProject/', src)
                .then(saveProjectSuccessHandler, saveProjectErrorHandler);
        }
        function getProjectsSuccessHandler(results) {
            if (results.data && results.data.length) {
                var result = [];
                angular.forEach(results.data, function (d) {
                    var dr = updateOrAddProject(d);
                    result.push(dr);
                });
                projects = result;
                messaging.publish(events.message._GET_PROJECT_LIST_COMPLETE_, [projects]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);

            } else {
                getProjectsErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getProjectSuccessHandler(results) {
            if (results.data) {
                project = updateOrAddProject(results.data);
                messaging.publish(events.message._GET_PROJECT_COMPLETE_, [project]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                getProjectErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function getProjectResourcesSuccessHandler(results) { 
            if (results.data) { 
                messaging.publish(events.message._GET_PROJECT_RESOURCES_LIST_COMPLETE_, [results.data]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                getProjectErrorHandler({ data: { error_description: 'No Records Returned' } });
            }
        }
        function deleteProjectSuccessHandler(results) {
            if (results) {
                var id = angular.toJson(results.data.ProjectId);
                var ix = -1;
                var match = $filter('filter')(projects, function (p) {
                    return Number(p.ProjectId) === Number(id);
                })[0];
                if (match) {
                    ix = projects.indexOf(match);
                }
                if (ix >= 0) {
                    projects.splice(ix, 1);
                    messaging.publish(events.message._PROJECT_LIST_UPDATED_, [projects]);
                }
                messaging.publish(events.message._DELETE_PROJECT_COMPLETE_, [id]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            } else {
                deleteProjectErrorHandler({ data: { error_description: 'No Records Deleted' } });
            }
        }
        function showSuccess() {
            $("#success-alert").alert();
            $("#success-alert").fadeTo(2000, 500).slideUp(500, function () {
                //$("#success-alert").alert('close');
            });
        }
        function saveProjectSuccessHandler(results) {
            if (results.data) {
                var result = results.data;
                project = updateOrAddProject(result);
                doFileUploads(results.data.ProjectId, results.data.LastUpdatedBy);

                messaging.publish(events.message._SAVE_PROJECT_COMPLETE_, [project]);
                messaging.publish(events.message._PROJECT_LIST_UPDATED_, [projects]);
                messaging.publish(events.message._SERVER_REQUEST_ENDED_);
                messaging.publish(events.message._SAVE_SUCCESS_);

            } else {
                saveProjectErrorHandler({ data: { error_description: 'No Records Saved' } });
            }
        }
        function updateOrAddProject(result) {
            project = modelTransformer.transform(result, Project);

            var students = [];
            angular.forEach(project.Students, function (d) {
                var dr = modelTransformer.transform(d, FireHour);
                students.push(dr);
            });
            project.Students = students;

            return project;
        }

        function getProjectErrorHandler(results) {
            messaging.publish(events.message._GET_PROJECT_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Project from the server', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_); 
        }
        function getProjectsErrorHandler(results) {
            messaging.publish(events.message._GET_PROJECT_LIST_FAILED);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Project List', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_); 
        }
        function getProjectResourcesErrorHandler(results) {
            messaging.publish(events.message._GET_PROJECT_RESOURCES_LIST_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to get Project Resources List', 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_); 
        }
        function deleteProjectErrorHandler(results) {
            messaging.publish(events.message._DELETE_PROJECT_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to Delete Project from the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        function saveProjectErrorHandler(results) {
            messaging.publish(events.message._SAVE_PROJECT_FAILED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_,
                ['Unable to save Project to the server ' + results.data.error_description, 'alert-danger']);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }

        //------------------------------------------------------

        function doFileUploads(ProjectId, LastUpdatedBy) {
            if (document.getElementById("fileUploadDocs").value != "") {
                var file = document.getElementById("fileUploadDocs").files[0];
                var fileName = document.getElementById("fileUploadDocs").files[0].name;
                if (window.FormData !== undefined) {
                    var data = new FormData();
                    data.append("file", file);
                    fileName = btoa(fileName);

                    $.ajax({
                        type: "POST",
                        url: baseUrl + "UploadFile/" + ProjectId + "/" + LastUpdatedBy + "/" + fileName,
                        contentType: false,
                        processData: false,
                        data: data,
                        success: function (result) {
                            console.info(result);
                        },
                        error: function (xhr, status, p3, p4) {
                            var err = "Error " + " " + status + " " + p3 + " " + p4;
                            if (xhr.responseText && xhr.responseText[0] == "{")
                                err = JSON.parse(xhr.responseText).Message;
                            console.error(err);
                        }
                    });
                }
                document.getElementById("fileUploadDocs").value = "";
                document.getElementById('btnSaveDoc').disabled = true;
            }
        }

        //--------------------------------------------------------
    }
})();